import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const day = (ts) => (ts ? new Date(ts * 1000).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-");
const input = "bg-[#0B0D14] border border-[#1F2937] rounded px-3 py-2 text-sm";

function GrantForm({ onDone }) {
  const [f, setF] = useState({ email: "", percent: 20, days: 40, note: "" });
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    try {
      await api.post("/admin/discounts", { ...f, percent: Number(f.percent), days: Number(f.days) || null });
      setF({ email: "", percent: 20, days: 40, note: "" }); onDone();
    } catch (ex) {
      const det = ex?.response?.data?.detail;
      setErr(Array.isArray(det) ? det.map((x) => x.msg).join("; ") : det || "Couldn't add the discount");
    }
  };
  return (
    <form onSubmit={submit} className="mt-4 flex flex-wrap items-end gap-2" data-testid="discount-form">
      <input required type="email" value={f.email} onChange={set("email")} placeholder="customer@email.com" data-testid="discount-email" className={`${input} w-64`} />
      <label className="text-[10px] mono uppercase text-[#94A3B8]">% off<input type="number" min="5" max="100" value={f.percent} onChange={set("percent")} data-testid="discount-percent" className={`${input} w-20 block mt-1`} /></label>
      <label className="text-[10px] mono uppercase text-[#94A3B8]">Days to use<input type="number" min="1" max="365" value={f.days} onChange={set("days")} data-testid="discount-days" className={`${input} w-24 block mt-1`} /></label>
      <input value={f.note} onChange={set("note")} placeholder="Note (e.g. Instagram giveaway)" maxLength={120} data-testid="discount-note" className={`${input} w-64`} />
      <button data-testid="discount-add" className="mono text-[11px] uppercase tracking-widest px-4 py-2.5 rounded bg-[#FBBF24] text-[#050914] font-semibold">Give discount</button>
      {err && <div className="w-full text-xs text-[#F87171]" data-testid="discount-error">{err}</div>}
    </form>
  );
}

export default function DiscountsCard() {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/admin/discounts").then((r) => setD(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const revoke = async (id) => { await api.delete(`/admin/discounts/${id}`); load(); };
  return (
    <section data-testid="discounts-card" className="mt-8 border border-[#FBBF24]/30 rounded-lg p-5 bg-[#0B0D14]">
      <h2 className="text-xl font-medium">First-month discounts</h2>
      {d && (
        <p className="text-sm text-[#94A3B8] mt-1" data-testid="discounts-launch-summary">
          Launch list: <b className="text-[#FBBF24]">{d.launch_list_count}</b> emails get {d.launch_percent}% off their first month automatically
          {d.launched_at ? `, until ${day(d.launch_deadline)} (40 days after launch on ${day(d.launched_at)}).` : " - the 40-day window starts when you open the store."}
          {" "}Applied at checkout when the account email matches. One use per account.
        </p>
      )}
      <GrantForm onDone={load} />
      <div className="mt-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="mono text-[10px] uppercase tracking-widest text-[#64748B]">
            <tr>{["Email", "% off", "Use by", "Note", "Given", ""].map((h) => <th key={h} className="text-left px-2 py-1">{h}</th>)}</tr>
          </thead>
          <tbody>
            {(d?.grants || []).map((g) => (
              <tr key={g.id} data-testid={`discount-row-${g.email}-${g.id}`} className={`border-t border-blue-900/20 ${g.revoked ? "opacity-40" : ""}`}>
                <td className="px-2 py-1.5">{g.email}</td><td className="px-2">{g.percent}%</td><td className="px-2">{g.expires_at ? day(g.expires_at) : "No deadline"}</td>
                <td className="px-2 text-[#94A3B8]">{g.note || "-"}</td><td className="px-2 text-[#94A3B8]">{day(g.created_at)}</td>
                <td className="px-2 text-right">{g.revoked ? "Removed" : <button onClick={() => revoke(g.id)} data-testid={`discount-revoke-${g.email}-${g.id}`} className="text-xs text-[#F87171] underline">Remove</button>}</td>
              </tr>
            ))}
            {d && !d.grants.length && <tr><td colSpan={6} className="px-2 py-3 text-[#64748B]">No hand-out discounts yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
